import React from 'react';

const Modal = ({ children, id, onClose, modalSize, modalStyle }) => {
    return (
        <div className="modal fade" id={id.replace('#', '')} data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div className={`modal-dialog ${modalSize ? modalSize : ''}`} style={modalStyle || {}} >
                <div className="modal-content">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default Modal;